// Small helpers to normalize FastAPI error payloads → strings.
export function formatDetail(d, fallback = "Something went wrong.") {
  if (d == null) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    return d.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  }
  if (typeof d === "object") {
    // RC10s / RC10t · Structured diagnostic envelope — surface the
    // first blocking reason's human message rather than JSON.stringify.
    if (Array.isArray(d.blocking_reasons) && d.blocking_reasons.length) {
      const br = d.blocking_reasons[0];
      if (br && typeof br.message === "string") return br.message;
    }
    if (typeof d.message === "string") return d.message;
    if (typeof d.msg === "string") return d.msg;
    return JSON.stringify(d);
  }
  return String(d);
}

export function apiError(err) {
  return formatDetail(err?.response?.data?.detail, err?.message);
}
